"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketTaggingInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketTaggingInput.js.map